<template>
  <div class="policy-violation-container">
    <v-container class="d-flex flex-column align-center justify-center" style="min-height: 80vh;">
      <v-card class="pa-8 text-center" max-width="600" elevation="2">
        <v-icon color="error" size="80" class="mb-4">
          mdi-alert-circle-outline
        </v-icon>

        <h2 class="mb-2 error--text" style="font-size: 32px; font-weight: 600;">
          Store Temporarily Suspended
        </h2>
        <h3 class="mb-4 grey--text" style="font-size: 28px; font-weight: 500;">
          Cửa hàng bị tạm khóa
        </h3>

        <p class="mb-3 grey--text text--darken-1" style="font-size: 18px; font-weight: 400;">
          Your store has been temporarily suspended due to policy violations. Please contact our support team for
          assistance and resolution.
        </p>
        <p class="mb-6 grey--text" style="font-size: 16px; font-weight: 400;">
          Cửa hàng của bạn hiện tại đã bị tạm khóa do vi phạm chính sách của nền tảng. Vui lòng liên hệ với bộ phận hỗ
          trợ để được giải quyết.
        </p>

        <v-divider class="my-6"></v-divider>

        <!-- <div class="mb-6">
          <h3 class="text-h6 mb-2">Support Contact Information</h3>
          <p class="text-body-2 mb-3 grey--text">Thông tin liên hệ hỗ trợ</p>
          <v-chip class="ma-2" color="primary" outlined>
            <v-icon left>mdi-email</v-icon>
            support@premitrax.com
          </v-chip>
          <v-chip class="ma-2" color="primary" outlined>
            <v-icon left>mdi-phone</v-icon>
            1900-xxxx-xxx
          </v-chip>
        </div> -->

        <!-- <v-btn color="primary" large @click="contactSupport" class="mb-4">
          <v-icon left>mdi-headset</v-icon>
          Contact Support / Liên hệ hỗ trợ
        </v-btn>

        <div>
          <v-btn text color="grey" @click="logout">
            <v-icon left>mdi-logout</v-icon>
            Sign Out / Đăng xuất
          </v-btn>
        </div> -->
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'PolicyViolation',

  methods: {
    contactSupport() {
      // Open email client or redirect to contact page
      window.location.href =
        'mailto:support@premitrax.com?subject=Store Unlock Request - Yêu cầu mở khóa cửa hàng&body=Hello, I need assistance to unlock my store.%0D%0A%0D%0AXin chào, tôi cần hỗ trợ mở khóa cửa hàng của mình.';
    },

    logout() {
      // Clear authentication data and redirect to login page
      localStorage.removeItem('premitrax-user');
      localStorage.removeItem('authToken');
      this.$router.push({ name: 'auth' });
    },
  },
};
</script>

<style scoped>
.policy-violation-container {
  min-height: 100vh;
}

.v-card {
  border-radius: 16px !important;
}
</style>
